import { ENV_IS_PROD } from "./envVars";
import { fakeGetResponsesByActionTypeDictionary } from "../utils/fakeResponses";

const envs = {
  local: "local",
  develop: "develop",
  release: "release",
  prod: "prod",
};
const developOptionsConfig = {
  local: {
    SHOW_MISSING_TRANSLATIONS_IN_LOG: true,
    USE_FAKE_SERVICES_ON_POST_OR_PATCH: false,
    USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS: false,
    USE_FAKE_FORMS_AS_DEFAULT_VALUES: false,
    SHOW_DEV_OPTIONS: false,
    SHOW_TEST_BUTTON: true,
    ALLOW_TEST_APPLICATION_VIEW: true,
    SHOW_DEV_CONSOLE_LOG: true,
    ACTION_TYPES_NOT_TO_BE_FAKED: [
      "REQUEST_POST_SESSION_TOKEN",
      "REQUEST_POST_LOAN_CALCULATOR",
      // "REQUEST_POST_LOAN_CALCULATOR",
      // "REQUEST_UPLOAD_BORROWER_DOCUMENTATION",
    ],
    FAKE_DEFAULT_SERVICE: ({ type, payload }) => ({
      route: `healthcheck/ping?fake-${type}=`,
      method: "get",
      headers: {
        "X-HTTP-Method-Override": "GET",
      },
      body: payload,
    }),
    FAKE_GET_RESPONSES_BY_ACTION_TYPE_DICTIONARY:
      fakeGetResponsesByActionTypeDictionary,
  },
  develop: {
    SHOW_MISSING_TRANSLATIONS_IN_LOG: false,
    USE_FAKE_SERVICES_ON_POST_OR_PATCH: false,
    USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS: false,
    USE_FAKE_FORMS_AS_DEFAULT_VALUES: false,
    SHOW_DEV_OPTIONS: false,
    SHOW_TEST_BUTTON: true,
    ALLOW_TEST_APPLICATION_VIEW: true,
    SHOW_DEV_CONSOLE_LOG: true,
    ACTION_TYPES_NOT_TO_BE_FAKED: ["REQUEST_AUTH"],
    FAKE_DEFAULT_SERVICE: ({ type, payload }) => ({
      route: `healthcheck/ping?fake-${type}=`,
      method: "get",
      headers: {
        "X-HTTP-Method-Override": "GET",
      },
      body: payload,
    }),
    FAKE_GET_RESPONSES_BY_ACTION_TYPE_DICTIONARY:
      fakeGetResponsesByActionTypeDictionary,
  },
  release: {
    SHOW_MISSING_TRANSLATIONS_IN_LOG: false,
    USE_FAKE_SERVICES_ON_POST_OR_PATCH: false,
    USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS: false,
    USE_FAKE_FORMS_AS_DEFAULT_VALUES: false,
    SHOW_DEV_OPTIONS: false,
    SHOW_TEST_BUTTON: true,
    ALLOW_TEST_APPLICATION_VIEW: true,
    SHOW_DEV_CONSOLE_LOG: false,
    ACTION_TYPES_NOT_TO_BE_FAKED: [],
    FAKE_DEFAULT_SERVICE: () => {
      console.error("---- Faking Services not allowed in staging ----");
    },
  },
  prod: {
    SHOW_MISSING_TRANSLATIONS_IN_LOG: false,
    USE_FAKE_SERVICES_ON_POST_OR_PATCH: false,
    USE_FAKE_RESPONSES_ON_DEFINED_FAKE_ACTIONS: false,
    USE_FAKE_FORMS_AS_DEFAULT_VALUES: false,
    SHOW_DEV_OPTIONS: false,
    SHOW_TEST_BUTTON: false,
    ALLOW_TEST_APPLICATION_VIEW: false,
    SHOW_DEV_CONSOLE_LOG: false,
    ACTION_TYPES_NOT_TO_BE_FAKED: [],
    FAKE_DEFAULT_SERVICE: () => {
      console.error("---- Faking Services not allowed in production ----");
    },
  },
};
const env =
  ENV_IS_PROD === "true"
    ? envs.prod
    : !window.RUNTIME_API_URL
    ? envs.local
    : window.RUNTIME_API_URL.includes("dev.nemuru.io")
    ? envs.develop
    : window.RUNTIME_API_URL.includes("stg.nemuru.io")
    ? envs.release
    : envs.prod;
export const developOptions = developOptionsConfig[env];
